(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }

  root.WifiCandyHomeSplitBanner = api;
  api.autoInit(root.document);
})(typeof self !== 'undefined' ? self : globalThis, function () {
  const EUROPE_ALIASES = [
    'europe', 'eu', 'france', 'paris', 'germany', 'berlin', 'spain', 'madrid',
    'italy', 'rome', 'portugal', 'lisbon', 'netherlands', 'amsterdam',
    'belgium', 'brussels', 'austria', 'vienna', 'greece', 'athens',
    'switzerland', 'zurich', 'croatia', 'zagreb', 'czech republic', 'prague',
    'denmark', 'copenhagen', 'finland', 'helsinki', 'hungary', 'budapest',
    'norway', 'oslo', 'poland', 'warsaw', 'romania', 'bucharest', 'sweden',
    'stockholm', 'slovakia', 'bratislava', 'slovenia', 'ljubljana',
    'bulgaria', 'sofia', 'estonia', 'tallinn', 'latvia', 'riga',
    'lithuania', 'vilnius', 'luxembourg', 'malta', 'cyprus'
  ];

  const NORTH_AMERICA_ALIASES = [
    'north america', 'usa', 'us', 'united states', 'america', 'american',
    'canada', 'canadian', 'mexico', 'mexican', 'new york', 'los angeles',
    'san francisco', 'miami', 'chicago', 'dallas', 'toronto', 'vancouver',
    'montreal', 'mexico city'
  ];

  const ANZ_ALIASES = [
    'australia', 'australian', 'aus', 'oz', 'sydney', 'melbourne', 'brisbane',
    'perth', 'adelaide', 'gold coast', 'new zealand', 'nz', 'kiwi',
    'aotearoa', 'auckland', 'wellington', 'christchurch', 'oceania'
  ];

  const WORLDWIDE_ALIASES = [
    'worldwide', 'world wide', 'world', 'global', 'international', 'everywhere',
    'asia', 'middle east', 'uae', 'dubai', 'abu dhabi', 'japan', 'tokyo',
    'south korea', 'korea', 'seoul', 'china', 'beijing', 'hong kong', 'taiwan',
    'taipei', 'singapore', 'thailand', 'bangkok', 'vietnam', 'hanoi',
    'philippines', 'manila', 'indonesia', 'bali', 'jakarta', 'malaysia',
    'kuala lumpur', 'india', 'delhi', 'mumbai', 'africa', 'south africa',
    'cape town', 'latin america', 'south america', 'brazil', 'sao paulo',
    'argentina', 'buenos aires'
  ];

  const ROUTES = [
    {
      key: 'ireland',
      label: 'Ireland',
      placeholderLabel: 'Ireland',
      meta: 'Dublin, Galway, Cork and more',
      flag: '🇮🇪',
      popularRank: 0,
      aliases: [
        'ireland', 'eire', 'irish', 'dublin', 'galway', 'cork', 'limerick',
        'shannon', 'kerry'
      ]
    },
    {
      key: 'ireland_uk',
      label: 'Ireland & UK & Europe',
      placeholderLabel: 'UK',
      meta: 'Includes UK, Northern Ireland and Europe coverage',
      flag: '🇬🇧',
      popularRank: 1,
      aliases: [
        'uk', 'united kingdom', 'britain', 'great britain', 'gb', 'england',
        'scotland', 'wales', 'northern ireland', 'belfast', 'london',
        'manchester', 'liverpool', 'edinburgh', 'glasgow', 'cardiff'
      ]
    },
    {
      key: 'europe',
      label: 'Europe',
      placeholderLabel: 'Europe',
      meta: 'Covers top EU travel destinations',
      flag: '🇪🇺',
      popularRank: 2,
      aliases: EUROPE_ALIASES
    },
    {
      key: 'north_america',
      label: 'North America',
      placeholderLabel: 'USA',
      meta: 'USA, Canada and Mexico',
      flag: '🌎',
      popularRank: 3,
      aliases: NORTH_AMERICA_ALIASES
    },
    {
      key: 'anz',
      label: 'Australia & New Zealand',
      placeholderLabel: 'Australia',
      meta: 'Australia, NZ and nearby travel',
      flag: '🇦🇺',
      popularRank: 5,
      aliases: ANZ_ALIASES
    },
    {
      key: 'worldwide',
      label: 'Worldwide Travel',
      placeholderLabel: 'Worldwide',
      meta: 'Asia, Middle East and beyond',
      flag: '🌍',
      popularRank: 4,
      aliases: WORLDWIDE_ALIASES
    }
  ];

  const ROUTE_LOOKUP = ROUTES.reduce((accumulator, route) => {
    accumulator[route.key] = Object.assign({}, route, {
      searchTerms: buildSearchTerms(route)
    });
    return accumulator;
  }, {});

  function buildSearchTerms(route) {
    const values = new Set([route.label, route.meta].concat(route.aliases));
    return Array.from(values)
      .map(normalize)
      .filter(Boolean);
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function inferRouteKeyFromText(value) {
    const normalizedValue = normalize(value);
    if (!normalizedValue) {
      return null;
    }

    if (normalizedValue.includes('worldwide')) {
      return 'worldwide';
    }

    if (
      normalizedValue.includes('australia') ||
      normalizedValue.includes('new zealand')
    ) {
      return 'anz';
    }

    if (normalizedValue.includes('north america')) {
      return 'north_america';
    }

    if (
      normalizedValue.includes('uk') ||
      normalizedValue.includes('northern ireland') ||
      normalizedValue.includes('united kingdom')
    ) {
      return 'ireland_uk';
    }

    if (normalizedValue.includes('europe')) {
      return 'europe';
    }

    if (normalizedValue.includes('ireland')) {
      return 'ireland';
    }

    return null;
  }

  function inferRouteKey(product) {
    if (!product) {
      return null;
    }

    const explicitKey = normalize(product.routeKey).replace(/\s+/g, '_');
    if (ROUTE_LOOKUP[explicitKey]) {
      return explicitKey;
    }

    return (
      inferRouteKeyFromText(product.handle) ||
      inferRouteKeyFromText(product.title)
    );
  }

  function buildCatalogIndex(rawProducts) {
    return (rawProducts || []).reduce((catalog, product) => {
      const routeKey = inferRouteKey(product);

      if (!routeKey || catalog[routeKey]) {
        return catalog;
      }

      catalog[routeKey] = {
        id: product.id || null,
        title: product.title || ROUTE_LOOKUP[routeKey].label,
        handle: product.handle || '',
        url: product.url || '',
        routeKey
      };

      return catalog;
    }, {});
  }

  function scoreRoute(route, query) {
    const normalizedQuery = normalize(query);

    if (!normalizedQuery || normalizedQuery.length < 2) {
      return 0;
    }

    let score = 0;
    const queryTokens = normalizedQuery.split(' ');

    route.searchTerms.forEach((term) => {
      if (term === normalizedQuery) {
        score = Math.max(score, 140);
        return;
      }

      if (term.startsWith(normalizedQuery)) {
        score = Math.max(score, 115);
      }

      if (normalizedQuery.length >= 3 && term.includes(normalizedQuery)) {
        score = Math.max(score, 90);
      }

      if (queryTokens.length > 1 && queryTokens.every((token) => term.includes(token))) {
        score = Math.max(score, 100);
      }

      if (
        queryTokens.length === 1 &&
        normalizedQuery.length >= 3 &&
        term.split(' ').includes(normalizedQuery)
      ) {
        score = Math.max(score, 110);
      }
    });

    return score;
  }

  function toSuggestion(routeKey, product, score) {
    const route = ROUTE_LOOKUP[routeKey];
    return {
      routeKey,
      label: route.label,
      meta: route.meta,
      flag: route.flag,
      popularRank: route.popularRank,
      product,
      score
    };
  }

  function getPopularSuggestions(catalog, limit = 4) {
    return Object.keys(catalog)
      .map((routeKey) => toSuggestion(routeKey, catalog[routeKey], 0))
      .sort((left, right) => left.popularRank - right.popularRank)
      .slice(0, limit);
  }

  function getEmptyStateSuggestions(catalog) {
    const preferredOrder = ['ireland', 'ireland_uk', 'north_america'];

    return preferredOrder
      .filter((routeKey) => catalog[routeKey])
      .map((routeKey) => toSuggestion(routeKey, catalog[routeKey], 0));
  }

  function getPlaceholderText(catalog, limit = 4) {
    const preferredOrder = ['ireland', 'ireland_uk', 'europe', 'north_america'];
    const labels = preferredOrder
      .filter((routeKey) => catalog[routeKey])
      .slice(0, limit)
      .map((routeKey) => ROUTE_LOOKUP[routeKey].placeholderLabel || ROUTE_LOOKUP[routeKey].label);

    if (!labels.length) {
      return 'Search destinations';
    }

    return labels.join(', ');
  }

  function getNavigationLocation(rootNode) {
    const browserLocation =
      rootNode &&
      rootNode.ownerDocument &&
      rootNode.ownerDocument.defaultView &&
      rootNode.ownerDocument.defaultView.location;

    if (browserLocation) {
      return browserLocation;
    }

    if (typeof globalThis !== 'undefined' && globalThis.location) {
      return globalThis.location;
    }

    return null;
  }

  function getSuggestions(query, catalog, limit = 5) {
    const normalizedQuery = normalize(query);
    if (!normalizedQuery) {
      return getPopularSuggestions(catalog, limit);
    }

    const suggestions = Object.keys(catalog)
      .map((routeKey) => toSuggestion(routeKey, catalog[routeKey], scoreRoute(ROUTE_LOOKUP[routeKey], normalizedQuery)))
      .filter((suggestion) => suggestion.score > 0)
      .sort((left, right) => {
        if (right.score !== left.score) {
          return right.score - left.score;
        }

        return left.popularRank - right.popularRank;
      });

    return suggestions.slice(0, limit);
  }

  function resolveSuggestion(query, catalog) {
    const suggestions = getSuggestions(query, catalog, 5);

    if (!suggestions.length) {
      return null;
    }

    if (suggestions[0].score >= 140) {
      return suggestions[0];
    }

    if (suggestions.length === 1 && suggestions[0].score >= 90) {
      return suggestions[0];
    }

    if (
      suggestions[0].score >= 115 &&
      (!suggestions[1] || suggestions[0].score - suggestions[1].score >= 20)
    ) {
      return suggestions[0];
    }

    return null;
  }

  function readProducts(rootNode) {
    const configNode = rootNode.querySelector('[data-home-split-banner-products]');

    if (!configNode) {
      return [];
    }

    try {
      const payload = JSON.parse(configNode.textContent || '{}');
      return Array.isArray(payload.products) ? payload.products : [];
    } catch (error) {
      return [];
    }
  }

  class HomeSplitBannerController {
    constructor(rootNode) {
      this.root = rootNode;
      this.catalog = buildCatalogIndex(readProducts(rootNode));
      this.form = this.root.querySelector('[data-home-split-banner-form]');
      this.input = this.root.querySelector('[data-home-split-banner-input]');
      this.results = this.root.querySelector('[data-home-split-banner-results]');
      this.submitButton = this.root.querySelector('[data-home-split-banner-submit]');
      this.status = this.root.querySelector('[data-home-split-banner-status]');
      this.state = {
        suggestions: [],
        activeIndex: -1,
        searchTimeout: null
      };
      this.onSubmit = null;
      this.onFocus = null;
      this.onInput = null;
      this.onKeydown = null;
      this.onResultsMousedown = null;
      this.onDocumentClick = null;

      if (!this.form || !this.input || !this.results || !this.submitButton) {
        return;
      }

      this.syncAvailabilityState();
      this.bindEvents();
    }

    bindEvents() {
      this.onSubmit = (event) => {
        event.preventDefault();
        this.handleSubmit();
      };
      this.onFocus = () => {
        if (!normalize(this.input.value)) {
          this.renderSuggestions(getEmptyStateSuggestions(this.catalog));
          return;
        }

        this.search(this.input.value);
      };
      this.onInput = (event) => {
        this.debounceSearch(event.target.value);
      };
      this.onKeydown = (event) => {
        this.handleKeydown(event);
      };
      this.onResultsMousedown = (event) => {
        event.preventDefault();
      };
      this.onDocumentClick = (event) => {
        if (!event.target.closest('[data-home-split-banner]')) {
          this.closeResults();
        }
      };

      this.form.addEventListener('submit', this.onSubmit);
      this.input.addEventListener('focus', this.onFocus);
      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('keydown', this.onKeydown);
      this.results.addEventListener('mousedown', this.onResultsMousedown);
      this.root.ownerDocument.addEventListener('click', this.onDocumentClick);
    }

    syncAvailabilityState() {
      const hasCatalog = Object.keys(this.catalog).length > 0;

      this.input.placeholder = getPlaceholderText(this.catalog);
      this.input.disabled = !hasCatalog;
      this.submitButton.disabled = !hasCatalog;
      this.submitButton.setAttribute('aria-disabled', hasCatalog ? 'false' : 'true');
      this.root.dataset.catalogReady = hasCatalog ? 'true' : 'false';

      if (!this.status) {
        return;
      }

      if (hasCatalog) {
        this.status.hidden = true;
        this.status.textContent = '';
        return;
      }

      this.status.hidden = false;
      this.status.textContent = 'Destination search is temporarily unavailable.';
    }

    debounceSearch(query) {
      clearTimeout(this.state.searchTimeout);
      this.state.searchTimeout = setTimeout(() => {
        this.search(query);
      }, 150);
    }

    search(query) {
      const suggestions = getSuggestions(query, this.catalog, 5);

      if (!suggestions.length) {
        this.closeResults();
        return;
      }

      this.renderSuggestions(suggestions);
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.closeResults();
        return;
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();

        if (!this.state.suggestions.length) {
          this.renderSuggestions(getPopularSuggestions(this.catalog));
        }

        this.moveActiveIndex(1);
        return;
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.moveActiveIndex(-1);
        return;
      }

      if (event.key === 'Enter') {
        event.preventDefault();

        if (this.state.activeIndex >= 0 && this.state.suggestions[this.state.activeIndex]) {
          this.navigateToSuggestion(this.state.suggestions[this.state.activeIndex]);
          return;
        }

        this.handleSubmit();
      }
    }

    moveActiveIndex(direction) {
      if (!this.state.suggestions.length) {
        return;
      }

      const lastIndex = this.state.suggestions.length - 1;
      const nextIndex = this.state.activeIndex + direction;

      if (nextIndex < 0) {
        this.setActiveIndex(lastIndex);
        return;
      }

      if (nextIndex > lastIndex) {
        this.setActiveIndex(0);
        return;
      }

      this.setActiveIndex(nextIndex);
    }

    setActiveIndex(index) {
      const items = this.results.querySelectorAll('[data-home-split-banner-option]');
      this.state.activeIndex = index;

      items.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');

        if (isActive) {
          this.input.setAttribute('aria-activedescendant', item.id);
        }
      });
    }

    handleSubmit() {
      const normalizedQuery = normalize(this.input.value);

      if (!normalizedQuery) {
        this.input.focus();
        this.renderSuggestions(getEmptyStateSuggestions(this.catalog));
        return;
      }

      const resolvedSuggestion = resolveSuggestion(normalizedQuery, this.catalog);

      if (resolvedSuggestion) {
        this.navigateToSuggestion(resolvedSuggestion);
        return;
      }

      this.search(normalizedQuery);

      if (!this.state.suggestions.length) {
        this.renderSuggestions(getEmptyStateSuggestions(this.catalog));
      }
    }

    renderSuggestions(suggestions) {
      this.state.suggestions = suggestions;
      this.state.activeIndex = -1;
      this.results.innerHTML = '';

      suggestions.forEach((suggestion, index) => {
        const option = this.createOption(suggestion, index);
        this.results.appendChild(option);
      });

      this.results.classList.add('is-visible');
      this.input.setAttribute('aria-expanded', 'true');
      this.input.removeAttribute('aria-activedescendant');
    }

    createOption(suggestion, index) {
      const option = this.root.ownerDocument.createElement('div');
      option.id = `${this.root.dataset.sectionId || 'home-split-banner'}-option-${index}`;
      option.className = 'home-split-banner__result-option';
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', 'false');
      option.setAttribute('data-home-split-banner-option', '');

      const flag = this.root.ownerDocument.createElement('span');
      flag.className = 'home-split-banner__result-flag';
      flag.textContent = suggestion.flag;

      const copy = this.root.ownerDocument.createElement('span');
      copy.className = 'home-split-banner__result-copy';

      const label = this.root.ownerDocument.createElement('span');
      label.className = 'home-split-banner__result-label';
      label.textContent = suggestion.label;

      const meta = this.root.ownerDocument.createElement('span');
      meta.className = 'home-split-banner__result-meta';
      meta.textContent = suggestion.meta;

      copy.appendChild(label);
      copy.appendChild(meta);
      option.appendChild(flag);
      option.appendChild(copy);

      option.addEventListener('mouseenter', () => {
        this.setActiveIndex(index);
      });

      option.addEventListener('click', () => {
        this.navigateToSuggestion(suggestion);
      });

      return option;
    }

    navigateToSuggestion(suggestion) {
      if (!suggestion || !suggestion.product || !suggestion.product.url) {
        return;
      }

      const location = getNavigationLocation(this.root);
      if (!location) {
        return;
      }

      location.href = suggestion.product.url;
    }

    closeResults() {
      this.state.suggestions = [];
      this.state.activeIndex = -1;
      this.results.classList.remove('is-visible');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
    }

    destroy() {
      clearTimeout(this.state.searchTimeout);

      if (this.form && this.onSubmit) {
        this.form.removeEventListener('submit', this.onSubmit);
      }

      if (this.input && this.onFocus) {
        this.input.removeEventListener('focus', this.onFocus);
      }

      if (this.input && this.onInput) {
        this.input.removeEventListener('input', this.onInput);
      }

      if (this.input && this.onKeydown) {
        this.input.removeEventListener('keydown', this.onKeydown);
      }

      if (this.results && this.onResultsMousedown) {
        this.results.removeEventListener('mousedown', this.onResultsMousedown);
      }

      if (this.root.ownerDocument && this.onDocumentClick) {
        this.root.ownerDocument.removeEventListener('click', this.onDocumentClick);
      }
    }
  }

  const INSTANCES = new WeakMap();

  function initSection(rootNode) {
    if (!rootNode) {
      return rootNode;
    }

    const existingInstance = INSTANCES.get(rootNode);
    if (existingInstance) {
      return existingInstance;
    }

    rootNode.dataset.homeSplitBannerReady = 'true';
    const controller = new HomeSplitBannerController(rootNode);
    INSTANCES.set(rootNode, controller);
    return controller;
  }

  function destroySection(rootNode) {
    const controller = INSTANCES.get(rootNode);
    if (!controller) {
      return;
    }

    controller.destroy();
    INSTANCES.delete(rootNode);
    rootNode.removeAttribute('data-home-split-banner-ready');
  }

  function initAll(scope) {
    const context = scope || root.document;

    if (!context || !context.querySelectorAll) {
      return;
    }

    context.querySelectorAll('[data-home-split-banner]').forEach((node) => {
      initSection(node);
    });
  }

  function autoInit(doc) {
    if (!doc || doc.__wifiCandyHomeSplitBannerBound) {
      return;
    }

    doc.__wifiCandyHomeSplitBannerBound = true;

    const boot = () => initAll(doc);

    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    doc.addEventListener('shopify:section:load', (event) => {
      if (!event || !event.target) {
        return;
      }

      initAll(event.target);
    });

    doc.addEventListener('shopify:section:unload', (event) => {
      if (!event || !event.target || !event.target.querySelectorAll) {
        return;
      }

      event.target.querySelectorAll('[data-home-split-banner]').forEach((node) => {
        destroySection(node);
      });
    });
  }

  return {
    ROUTES,
    buildCatalogIndex,
    getEmptyStateSuggestions,
    getNavigationLocation,
    getPlaceholderText,
    getPopularSuggestions,
    getSuggestions,
    inferRouteKey,
    normalize,
    resolveSuggestion,
    autoInit,
    initAll,
    initSection
  };
});
